import { 
  Box, 
  Typography, 
  Grid,
} from '@material-ui/core';
import React from 'react';
import JobsPendingWidget from './Widgets/JobsPendingWidget';
import { RequestGroup } from './hooks/useServiceRequestSearch';

const WasteJobsOverviewDashboard: React.FC = () => {
  return (
    <>
      <Typography variant="h1">Overview of Jobs</Typography>
      <Box mt={4}>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={6}>
            <JobsPendingWidget title="Bin Deliveries" jobGroup={RequestGroup.BinDelivery} />
          </Grid>
          <Grid item xs={12} lg={6}>
            <JobsPendingWidget title="Missed Bins" jobGroup={RequestGroup.MissedBin} />
          </Grid>
        </Grid>        
      </Box>
    </>
  );
}

export default WasteJobsOverviewDashboard;